<template>
  <Modal :id="'cmp-add-booking'" @cancelled="onCancelClick">
    <!-- <div class="dt-modal--title-bar">
      <div class="dt-icon-container">
        <img
          src="static/icons/delete-gray.svg"
          class="dt-icon v5 s2"
          @click="onCancelClick"
          alt="Close Add Booking"
          title="Close Add Booking"
        />
      </div>
    </div>-->
    <template slot="header"> {{$t('add_booking')}} </template>
    <template slot="body">
      <v-tabs v-model="activeTab" class="dt-hide-tabbar" @change="onTabChange">
        <v-tab v-for="n in tabs" :key="n.value" ripple></v-tab>
        <v-tab-item>
          <div class="dt-modal--subtitle">{{ $t("basic_setup") }}</div>
          <v-layout row wrap class="tab-content basic-setup">
            <v-flex xs12 md6 class="dt-modal--column first-half">
              <div class="form-group">
                <TextField
                  :id="'startDate'"
                  class="m1"
                  :value="startDate"
                  :placeholder="$t('start_date')"
                  :type="'date'"
                  :showEditIconOnHover="false"
                  :showValidationIcons="true"
                  :statusInside="true"
                  @valuechanged="onStartDateChanged"
                  required
                  immediateValidation
                  @validated="onValidation"
                ></TextField>
                <TextField
                  :id="'endDate'"
                  :showEditIconOnHover="false"
                  :showValidationIcons="true"
                  :statusInside="true"
                  class="m1"
                  :value="endDate"
                  :placeholder="$t('end_date')"
                  :type="'date'"
                  @valuechanged="onEndDateChanged"
                  required
                  immediateValidation
                  @validated="onValidation"
                ></TextField>
                <TextField
                  :id="'city'"
                  class="m1"
                  v-bind="textFieldConfig"
                  v-model="city"
                  isModel
                  required
                  :placeholder="$t('city')"
                  @valuechanged="onCityValueChanged"
                  @validated="onValidation"
                  immediateValidation
                ></TextField>
                <Dropdown
                  class="m2"
                  :options="countriesTV"
                  :selected="countriesTV.find((e) => e.value == country)"
                  box
                  deselect
                  :placeholder="$t('country')"
                  v-on:selectedChange="(e) => onDropdownChange('country', e)"
                  :listHeight="260"
                  required
                  immediateValidation
                  showValidationIcons
                  statusInside
                  @validated="(e) => onValidation('country', e)"
                ></Dropdown>
                <!--  -->
                <TextField
                  class="m1"
                  :id="'eventName'"
                  v-bind="textFieldConfig"
                  v-model="eventName"
                  isModel
                  :placeholder="$t('date_name')"
                  @validated="onValidation"
                ></TextField>
                <Dropdown
                  class="dt-dropdown m2"
                  :options="statuses"
                  :selected="selectedStatus"
                  box
                  :listHeight="210"
                  :placeholder="$t('status')"
                  v-on:selectedChange="(e) => onDropdownChange('status', e)"
                >
                  <template v-slot:item="{ item }">
                    <div class="ut-flex status">
                      <div
                        class="status-color"
                        :style="{
                          backgroundColor: `${statusColor[item.value]}`,
                        }"
                      ></div>
                      <div class="status-text">
                        {{ item.text }}
                      </div>
                    </div>
                  </template>
                </Dropdown>
                <TextField
                  class="m1"
                  :id="'dealMemo'"
                  v-bind="textAreaConfig"
                  :showValidationIcons="false"
                  show
                  textarea
                  v-model="dealMemo"
                  isModel
                  :placeholder="$t('deal_memo_internal')"
                  @validated="onValidation"
                ></TextField>
              </div>
            </v-flex>
            <v-flex
              xs12
              md6
              style="margin-top: 5px"
              class="dt-modal--column second-half"
            >
              <SearchList
                :id="'artists'"
                ref="searchList"
                :selected="selectedArtists"
                :keyProperty="'artist_id'"
                :label="'artist_name'"
                :items="artists"
                @searched="searchArtist"
                @scrollNext="onArtistListScroll"
              >
              <!-- @selected="onArtistSelected" -->
                <template v-slot:item="{ item }">
                  <tr class="dt-table2--row">
                    <td class="dt-table2--column checkbox-column">
                      <div class="dt-checkbox v2 s1">
                        <input
                          type="checkbox"
                          name="name"
                          @click="(e) => onCheckboxChange(e, item)"
                        />
                        <div class="checkmark"></div>
                      </div>
                    </td>
                    <td class="dt-table2--column">
                      <span class="txtov">{{ item.artist_name }}</span>
                    </td>
                    <td class="dt-table2--column checkbox-column">
                      <span class="txtov">
                      <img
                          v-if="item.exclusive == 'Conflict'"
                          :src="`static/icons/artist-exclusivity/artist-exclusivity-inactive.svg`"
                          class="dt-icon s1"
                          style="cursor:auto;"
                          :title="item.toooltip"
                        />
                      </span>
                    </td>
                  </tr>
                </template>
              </SearchList>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item>
          <div class="dt-modal--subtitle">{{ $t("location") }}</div>
          <v-layout row wrap class="tab-content venues">
            <v-flex xs12 md6 class="dt-modal--column first-half">
              <SearchList
                :id="'venues'"
                ref="venueSearchList"
                :items="venues"
                :keyProperty="'booking_location_id'"
                :label="'booking_location_name'"
                :selectionNumber="'single'"
                @searched="searchVenue"
              >
                <template v-slot:item="{ item }">
                  <tr class="dt-table2--row" @click="onVenueSelected(item)">
                    <dt class="dt-table2--column">
                      <span class="txtov">{{
                        item.booking_location_name
                      }}</span>
                    </dt>
                    <dt class="dt-table2--column">
                      <span class="txtov">{{ item.city }}</span>
                    </dt>
                    <dt class="dt-table2--column">
                      <span class="txtov">{{ item.country }}</span>
                    </dt>
                  </tr>
                </template>
              </SearchList>
            </v-flex>
            <v-flex xs12 md6 class="dt-modal--column second-half">
              <div class="dt-modal--subtitle">
                {{ selectedVenue.booking_location_name || $t('selected_venue') }}
              </div>
              <div
                v-if="selectedVenue.booking_location_id"
                class="form-group venue-form"
              >
                <TextField
                  class="m1"
                  :id="'booking_location_name'"
                  v-bind="validationTextFieldConfig"
                  :value="selectedVenue.booking_location_name"
                  :placeholder="$t('location_name')"
                  @valuechanged="onVenueValueChanged"
                  @validated="onVenueValidation"
                  @blur="onVenueBlur"
                ></TextField>
                <TextField
                  class="m1"
                  :id="'address1'"
                  v-bind="textFieldConfig"
                  v-model="selectedVenue.address1"
                  :placeholder="$t('location') + ' ' + $t('address')"
                  @valuechanged="onVenueValueChanged"
                  @blur="onVenueBlur"
                ></TextField>
                <v-layout row wrap>
                  <v-flex md6 style="padding-right: 6px">
                    <TextField
                      class="m1"
                      :id="'city'"
                      v-bind="textFieldConfig"
                      v-model="selectedVenue.city"
                      :placeholder="$t('city')"
                      @valuechanged="onVenueValueChanged"
                      @blur="onVenueBlur"
                    ></TextField>
                  </v-flex>
                  <v-flex md6 style="padding-left: 6px">
                    <TextField
                      class="m1"
                      :id="'postalcode'"
                      v-bind="textFieldConfig"
                      v-model="selectedVenue.citpostalcode"
                      :placeholder="$t('postalcode')"
                      @valuechanged="onVenueValueChanged"
                      @blur="onVenueBlur"
                    ></TextField>
                  </v-flex>
                </v-layout>
                <Dropdown
                  class="dt-dropdown"
                  :options="countriesTV"
                  :selected="
                    countriesTV.find((e) => e.value == selectedVenue.country)
                  "
                  box
                  :showValidationIcons="true"
                  :immediateValidation="true"
                  :statusInside="true"
                  @validated="(e) => onVenueValidation('country', e)"
                  :placeholder="$t('rs_country')"
                  v-on:selectedChange="
                    (e) => onVenuDropdownChange('country', e)
                  "
                  :listHeight="95"
                ></Dropdown>
                <TextField
                  class="m1"
                  :id="'phone1'"
                  v-bind="textFieldConfig"
                  v-model="selectedVenue.phone1"
                  :placeholder="$t('phone')"
                  @valuechanged="onVenueValueChanged"
                  @blur="onVenueBlur"
                ></TextField>
                <TextField
                  class="m1"
                  :id="'email'"
                  v-bind="textFieldConfig"
                  v-model="selectedVenue.email"
                  :placeholder="$t('email')"
                  @valuechanged="onVenueValueChanged"
                  @blur="onVenueBlur"
                ></TextField>
                <TextField
                  class="m1"
                  :id="'url1'"
                  v-bind="textFieldConfig"
                  v-model="selectedVenue.url1"
                  :placeholder="$t('url_1')"
                  @valuechanged="onVenueValueChanged"
                  @blur="onVenueBlur"
                ></TextField>
                <TextField
                  class="m1"
                  :id="'venue_capacity'"
                  v-bind="textFieldConfig"
                  v-model="selectedVenue.venue_capacity"
                  :placeholder="$t('location') + ' ' + $t('capacity')"
                  @valuechanged="onVenueValueChanged"
                  @blur="onVenueBlur"
                ></TextField>

                <div v-if="map" ref="mapContainer">
                  <div
                    @mouseenter="onMapMouseEnter"
                    @mouseleave="onMapMouseLeave"
                    :class="{
                      expanded: mapExpanded,
                    }"
                    ref="mapElement"
                    id="google-map-element"
                  ></div>
                </div>
              </div>
              <!-- <div v-else class="add-item">
                <div class="add-item--row">
                  <button class="dt-button s6" @click="onAddVenue">Add Venue</button>
                </div>
              </div>-->
            </v-flex>
            <div ref="expandedMapContainer"></div>
          </v-layout>
        </v-tab-item>
        <v-tab-item>
          <div class="dt-modal--subtitle">
            {{
              linkablePromoters && linkablePromoters.length > 0
                ? `${linkablePromoters.length} ${this.$t(
                    "promoter_found_same_email"
                  )} `
                : `${this.$t("promoter")}`
            }}
          </div>
          <v-layout row wrap class="tab-content promoters">
            <v-flex xs12 md6 class="dt-modal--column first-half">
              <SearchList
                :id="
                  linkablePromoters && linkablePromoters.length > 0
                    ? 'linkable_promoters'
                    : 'promoters'
                "
                ref="promotersSearchList"
                :items="
                  linkablePromoters && linkablePromoters.length > 0
                    ? linkablePromoters
                    : promoters
                "
                :keyProperty="'contact_id'"
                :label="'first_name'"
                :selectionNumber="'single'"
                @searched="promoterSearched"
              >
                <template v-slot:item="{ item }">
                  <tr class="dt-table2--row" @click="onSelectPromoter(item)">
                    <dt class="dt-table2--column">
                      <span class="txtov">{{ getContactName(item) }}</span>
                    </dt>

                    <dt class="dt-table2--column">
                      <span class="txtov">{{ item.country }}</span>
                    </dt>
                  </tr>
                </template>
              </SearchList>
            </v-flex>
            <v-flex xs12 md6 class="dt-modal--column second-half">
              <div class="dt-modal--subtitle">
                {{ getContactName(selectedPromoter) || $t("selected_promoter") }}
              </div>
              <div
                class="form-group"
                v-if="selectedPromoter && selectedPromoter.contact_id"
              >
                <TextField
                  v-if="ContactFuncs.isNotIndividual(selectedPromoter)"
                  class="m1"
                  :id="'company_name'"
                  v-bind="validationTextFieldConfig"
                  :value="selectedPromoter.company_name"
                  :placeholder="$t('company_name')"
                  @valuechanged="onPromoterValueChanged"
                  @validated="onPromoterValidation"
                  @blur="onPromoterBlur"
                ></TextField>
                <TextField
                  v-if="ContactFuncs.isNotIndividual(selectedPromoter)"
                  class="m1"
                  :id="'company_legalname'"
                  v-bind="validationTextFieldConfig"
                  :value="selectedPromoter.company_legalname"
                  :placeholder="$t('legal_name')"
                  @valuechanged="onPromoterValueChanged"
                  @validated="onPromoterValidation"
                  @blur="onPromoterBlur"
                ></TextField>
                <TextField
                  v-if="ContactFuncs.isNotCompany(selectedPromoter)"
                  class="m1"
                  :id="'first_name'"
                  v-bind="validationTextFieldConfig"
                  :value="selectedPromoter.first_name"
                  :placeholder="$t('first_name')"
                  @valuechanged="onPromoterValueChanged"
                  @validated="onPromoterValidation"
                  @blur="onPromoterBlur"
                ></TextField>
                <TextField
                  v-if="ContactFuncs.isNotCompany(selectedPromoter)"
                  class="m1"
                  :id="'last_name'"
                  v-bind="validationTextFieldConfig"
                  :value="selectedPromoter.last_name"
                  :placeholder="$t('last_name')"
                  @valuechanged="onPromoterValueChanged"
                  @validated="onPromoterValidation"
                  @blur="onPromoterBlur"
                ></TextField>
                <TextField
                  class="m1"
                  :id="'address1'"
                  v-bind="textFieldConfig"
                  v-model="selectedPromoter.address1"
                  :placeholder="$t('address')"
                  @valuechanged="onPromoterValueChanged"
                  @blur="onPromoterBlur"
                ></TextField>
                <v-layout row wrap>
                  <v-flex md6 pr-1>
                    <TextField
                      class="m1"
                      :id="'city'"
                      v-bind="textFieldConfig"
                      v-model="selectedPromoter.city"
                      :placeholder="$t('city')"
                      @valuechanged="onPromoterValueChanged"
                      @blur="onPromoterBlur"
                    ></TextField>
                  </v-flex>
                  <v-flex md6 pl-1>
                    <TextField
                      class="m1"
                      :id="'postalcode'"
                      v-bind="textFieldConfig"
                      v-model="selectedPromoter.postalcode"
                      :placeholder="$t('postalcode')"
                      @valuechanged="onPromoterValueChanged"
                      @blur="onPromoterBlur"
                    ></TextField>
                  </v-flex>
                </v-layout>
                <TextField
                  class="m1"
                  :id="'region'"
                  v-bind="textFieldConfig"
                  v-model="selectedPromoter.region"
                  :placeholder="$t('market_area')"
                  @valuechanged="onPromoterValueChanged"
                  @blur="onPromoterBlur"
                ></TextField>
                <Dropdown
                  class="dt-dropdown"
                  :options="countriesTV"
                  :selected="
                    countriesTV.find((e) => e.value == selectedPromoter.country)
                  "
                  box
                  :placeholder="$t('country')"
                  v-on:selectedChange="
                    (e) => onPromoterDropdownChange('country', e)
                  "
                  :listHeight="95"
                  :statusInside="true"
                ></Dropdown>
                <TextField
                  class="m1"
                  :id="'email1'"
                  v-bind="validationTextFieldConfig"
                  v-model="selectedPromoter.email1"
                  :placeholder="$t('email')"
                  @valuechanged="onPromoterValueChanged"
                  @validated="onPromoterValidation"
                  @blur="onPromoterBlur"
                ></TextField>
                <TextField
                  class="m1"
                  :id="'phone1'"
                  v-bind="textFieldConfig"
                  v-model="selectedPromoter.phone1"
                  :placeholder="$t('phone1')"
                  @valuechanged="onPromoterValueChanged"
                  @blur="onPromoterBlur"
                ></TextField>
                <TextField
                  class="m1"
                  :id="'mobile1'"
                  v-bind="textFieldConfig"
                  v-model="selectedPromoter.mobile1"
                  :placeholder="$t('phone2')"
                  @valuechanged="onPromoterValueChanged"
                  @blur="onPromoterBlur"
                ></TextField>

                <TextField
                  class="m1"
                  :id="'vat_no'"
                  v-bind="textFieldConfig"
                  v-model="selectedPromoter.vat_no"
                  :placeholder="$t('rs_vat_id')"
                  @valuechanged="onPromoterValueChanged"
                  @blur="onPromoterBlur"
                ></TextField>
                <TextField
                  class="m1"
                  :id="'url1'"
                  v-bind="textFieldConfig"
                  v-model="selectedPromoter.url1"
                  :placeholder="$t('url_1')"
                  @valuechanged="onPromoterValueChanged"
                  @blur="onPromoterBlur"
                ></TextField>
              </div>
              <!-- <div v-else class="add-item">
                <div class="add-item--row">
                  <button class="dt-button s6" @click="onAddPromoter">Add Promoter</button>
                </div>
              </div>-->
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item>
          <div class="dt-modal--subtitle">{{ $t("main_contacts") }}</div>
          <v-layout row wrap class="tab-content contacts">
            <v-flex xs12 md6 class="dt-modal--column first-half">
              <SearchList
                :id="'contacts'"
                ref="contactsSearchList"
                :items="contacts"
                :keyProperty="'contact_id'"
                :label="'first_name'"
                :selectionNumber="'single'"
                @searched="searchContact"
              >
                <template v-slot:item="{ item }">
                  <tr class="dt-table2--row" @click="onSelectContact(item)">
                    <dt class="dt-table2--column">
                      <span class="txtov">{{ getContactName(item) }}</span>
                    </dt>
                    <dt class="dt-table2--column">
                      <span class="txtov">{{ item.city }}</span>
                    </dt>

                    <dt class="dt-table2--column">
                      <span class="txtov">{{ item.country }}</span>
                    </dt>
                  </tr>
                </template>
              </SearchList>
            </v-flex>
            <v-flex xs12 md6 class="dt-modal--column second-half">
              <div class="dt-modal--subtitle">
                {{ getContactName(selectedContact) || $t("selected_contact")  }}
              </div>
              <div
                class="form-group ab-entity-form"
                v-if="selectedContact && selectedContact.contact_id"
              >
                <TextField
                  class="m1"
                  :id="'first_name'"
                  v-bind="validationTextFieldConfig"
                  :value="selectedContact.first_name"
                  :placeholder="$t('first_name')"
                  @valuechanged="onContactValueChanged"
                  @validated="onContactValidation"
                  @blur="onContactBlur"
                ></TextField>
                <TextField
                  class="m1"
                  :id="'last_name'"
                  v-bind="validationTextFieldConfig"
                  v-model="selectedContact.last_name"
                  :placeholder="$t('last_name')"
                  @valuechanged="onContactValueChanged"
                  @validated="onContactValidation"
                  @blur="onContactBlur"
                ></TextField>
                <TextField
                  class="m1"
                  :id="'phone1'"
                  v-bind="textFieldConfig"
                  v-model="selectedContact.phone1"
                  :placeholder="$t('phone1')"
                  @valuechanged="onContactValueChanged"
                  @blur="onContactBlur"
                ></TextField>
                <TextField
                  class="m1"
                  :id="'mobile1'"
                  v-bind="textFieldConfig"
                  v-model="selectedContact.mobile1"
                  :placeholder="$t('phone2')"
                  @valuechanged="onContactValueChanged"
                  @blur="onContactBlur"
                ></TextField>
                <TextField
                  class="m1"
                  :id="'email1'"
                  v-bind="textFieldConfig"
                  v-model="selectedContact.email1"
                  :placeholder="$t('email')"
                  @valuechanged="onContactValueChanged"
                  @blur="onContactBlur"
                ></TextField>
                <v-layout row wrap>
                  <v-flex md6 pr-1>
                    <TextField
                      class="m1"
                      :id="'city'"
                      v-bind="textFieldConfig"
                      v-model="selectedContact.city"
                      :placeholder="$t('city')"
                      @valuechanged="onContactValueChanged"
                      @blur="onContactBlur"
                    ></TextField>
                  </v-flex>
                  <v-flex md6 pl-1>
                    <TextField
                      class="m1"
                      :id="'postalcode'"
                      v-bind="textFieldConfig"
                      v-model="selectedContact.postalcode"
                      :placeholder="$t('postalcode')"
                      @valuechanged="onContactValueChanged"
                      @blur="onContactBlur"
                    ></TextField>
                  </v-flex>
                </v-layout>
                <Dropdown
                  class="dt-dropdown"
                  :options="countriesTV"
                  :selected="
                    countriesTV.find((e) => e.value == selectedContact.country)
                  "
                  box
                  :placeholder="$t('country')"
                  v-on:selectedChange="
                    (e) => onContactDropdownChange('country', e)
                  "
                  :listHeight="95"
                ></Dropdown>
                <Dropdown
                  class="dt-dropdown"
                  :options="systemLanguagesTV"
                  :selected="
                    systemLanguagesTV.find(
                      (e) => e.value == selectedContact.language
                    )
                  "
                  box
                  :placeholder="$t('invoice_language')"
                  v-on:selectedChange="
                    (e) => onContactDropdownChange('language', e)
                  "
                  :listHeight="95"
                ></Dropdown>
              </div>
              <!-- <div v-else class="add-item">
                <div class="add-item--row">
                  <button class="dt-button s6">Add Contact</button>
                </div>
              </div>-->
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs>
    </template>
    <template slot="options">
      <div class="right-buttons">
        <button
          class="dt-button s6"
          @click="onBackClick"
          :disabled="!isBackButtonEnabled"
          :class="{
            disabled: !isBackButtonEnabled,
          }"
          :style="{
            visibility: isBackTabVisible ? 'visible' : 'hidden',
          }"
        >
          {{$t('back')}}
        </button>
        <button class="dt-button s6" @click="onNewClick" v-if="newButtonShow">
          {{$t('new')}} {{ createNewButtonText }}
        </button>
      </div>
      <button
        class="dt-button s6 v1"
        @click="onFinishClick"
        :disabled="!isFinishEnabled"
        :class="{
          disabled: !isFinishEnabled,
        }"
        :title="isFinishEnabledTitle"
      >
        {{$t('finish')}}
      </button>
      <button
        class="dt-button s6"
        @click="onNextClick"
        :disabled="!isNextButtonEnabled"
        :class="{
          disabled: !isNextButtonEnabled,
        }"
        :title="
          !isNextButtonEnabled
            ? 'please_make_sure'
            : nextButtonText
        "
        :style="{
          visibility: isNextTabVisible ? 'visible' : 'hidden',
        }"
      >
        {{ nextButtonText }}
      </button>
    </template>
  </Modal>
</template>

<script>
import * as R from "ramda";
import {
  BookingStoreNamespace as storeNS,
  BookingStoreNamespace,
} from "../../../store";
import * as ActionTypes from "../store/types";
import isEmail from "validator/lib/isEmail";

import Dropdown from "@plugins/dropdown/dropdown";
import TextField from "@plugins/text-field/text-field";

import { BookingService } from "../services/booking-service";
import { addRemoveSet, subscribeSubject, wait } from "../../../utility";
import InputField from "../../../plugins/text-field/input-field";
import { Subject, concat } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import {
  createValidator,
  resultValidity,
  EventHooks,
  createTextFieldConfig,
} from "../../../plugins/text-field";
import { mapGetters, Store } from "vuex";

import { createContact } from "../models/contact.model";
import { createVenue, VenueFuncs } from "../models/venue.model";

import { createUser } from "../../../models/user.model";
import { getName } from "../../contacts/models/contact-details.model";
import { scrollToWithAnimation } from "../../../plugins/scroller/scrollTo";

import Modal from "../../../dt-plugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { createCountriesTV } from "../../../models/country.model";
import { ContactFuncs } from "../../contacts/models/contacts.model";
import { AddBookingService } from "../services/add-booking.service";
import { NotificationService } from "../../../dt-plugins/notification/notification.service";
import { any, head, identity, keys, toPairs, zip } from "ramda";
import { format } from "date-fns";

export default {
  components: {
    Modal,
    InputField,
    SearchList,
  },
  props: {
    calendarDate: {
      type: String,
      default: format(new Date(), "YYYY-MM-DD"),
    },
    addBookingData: {
      type: Object,
    },
  },
  data: function () {
    // console.log('Executing Data Function');

    return {
      activeTab: "0",
      textAreaConfig: {
        height: 132,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        statusInside: true,
      },
      // textFieldConfig: {
      //   height: 42,
      //   showEditIconOnHover: false,
      //   box: true,
      //   showValidationIcons: true,
      //   statusInside: true,
      // },
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        statusInside: true,
        valueChangedEvent: EventHooks.OnBlur,
        validationEvent: EventHooks.OnBlur,
      },
      validationTextFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        required: true,
        showValidationIcons: true,
        statusInside: true,
        immediateValidation: true,
        valueChangedEvent: EventHooks.OnKeyup,
        validationEvent: EventHooks.OnKeyup,
      }),
      tabs: [
        { value: 0, text: "Basic Setup" },
        { value: 1, text: "Venu" },
        { value: 2, text: "Promoter" },
        { value: 3, text: "Contact" },
      ],
      emailValidators: [
        createValidator({
          name: "emailValidation",
          validatorFn: isEmail,
          errorMessage: "Must be a valid Email",
        }),
      ],

      validationResult: {},

      startDate: this.calendarDate,
      startDateMenu: null,
      endDate: this.calendarDate,
      endDateMenu: null,
      city: "",
      country: "",
      countries: [],
      selectedCountry: null,
      eventName: "",
      statuses: [],
      colorArray: [],
      selectedStatus: null,
      dealMemo: "",
      artists: [],
      selectedArtists: new Set(),
      artistSearchString: "",
      artistSearchSubject$: new Subject(),

      citySearchSubject$: new Subject(),
      contactCitySearchSubject: new Subject(),
      promoterCitySearchSubject: new Subject(),

      // Venu Tab Data

      venues: [],
      selectedVenue: createVenue({}),
      venuSearchString: "",
      venuSearchSubject$: new Subject(),
      venueValidationResult: {},

      // Google map data

      map: null,
      mapExpanded: false,
      markerInfoWindows: [],

      // Contact Functions
      ContactFuncs: ContactFuncs,

      // Promoter Tab Data

      promoters: [],
      selectedPromoter: createContact({}),
      promoterSearchString: "",
      promoterSearchSubject$: new Subject(),
      promoterValidationResult: {},
      promoterContinue: false,
      promoterVerifying: false,
      linkablePromoters: [],

      //Contacts Tab Data

      contacts: [],
      selectedContact: createContact({}),
      contactSearchString: "",
      contactSearchSubject$: new Subject(),
      contactValidationResult: {},

      // For Editing Booking
      calendarDateId: null,

      // First response
      user: createUser({}),

      //Booking Wizard Flag
      bookingWizard: false,

      loading: {
        basic: false,
        venue: false,
        promoter: false,
        contact: false,
      },
      statusColor: {},

      finishLoadingFlag: false,
      // Mark: Data,

      artistRowCount: 100,
    };
  },
  mounted: function () {
    BookingService.findBookingWizardInfo({
      bookingDate: this.calendarDate,
    }).then((res) => {
      console.log("WWWWW", res.data.statuses);
      this.statuses = res.data.statuses.map((e) => ({
        text: e.booking_status_name,
        value: e.booking_status_id,
      }));

      this.statusColor = res.data.statuses.reduce((accum, currentVal) => {
        accum[
          currentVal.booking_status_id
        ] = `#${currentVal.booking_status_colour}`;
        return accum;
      }, {});

      console.log("ACCUM", this.statusColor);
      // !TODO: Default Booking status is static.
      // !TODO: Should be Fetched from Server

      const status = res.data.statuses.find(
        (e) => e.booking_status_name == "TBC"
      );
      this.selectedStatus = status && {
        text: status.booking_status_name,
        value: status.booking_status_id,
      };

      this.countries = res.data.countries;

      this.artists = res.data.artists;
      if (this.bookingWizard == false) {
        // this.user = res.data.user;
        this.user = this.$store.getters.account.user;
      }
    });
    // BookingService.findCountriesOfCity({}).then(res => {
    // console.log(res);
    //   this.countries = res.data.countries.map(e => e.country);
    // })

    // Artist Subscription
    this.$subscribeTo(
      this.artistSearchSubject$
        .asObservable()
        .pipe(debounceTime(300), distinctUntilChanged()),
      (searchString) => {
        BookingService.findArtistBookingWizard({
          search: searchString,
        }).then((res) => {
          // console.log(res);
          this.artists = res.data.artists;
        });
      }
    );

    // City Subscription
    this.$subscribeTo(
      this.citySearchSubject$
        .asObservable()
        .pipe(debounceTime(300), distinctUntilChanged()),
      (searchString) => {
        // console.error(searchString);

        BookingService.findCountriesOfCity({
          city: searchString,
        }).then((res) => {
          // console.log(res);
          if (
            res.data.countries &&
            res.data.countries.length > 0 &&
            this.countriesTV.length != res.data.countries.length
          ) {
            // this.selectedCountry = res.data.countries[0].country;
            this.country = res.data.countries[0].country;
          }

          if(this.startDate && this.endDate && this.city && this.country){
            this.searchArtist();
          }
        });
      }
    );

    subscribeSubject(this, this.promoterCitySearchSubject, (searchString) => {
      BookingService.findCountriesOfCity({
        city: searchString,
      }).then((res) => {
        if (
          res.data.countries &&
          res.data.countries.length > 0 &&
          this.selectedContact.country &&
          this.countriesTV.length != res.data.countries.length
        ) {
          this.selectedPromoter.city = res.data.countries[0].country;
        }
      });
    });
    subscribeSubject(this, this.contactCitySearchSubject, (searchString) => {
      BookingService.findCountriesOfCity({
        city: searchString,
      }).then((res) => {
        if (
          res.data.countries &&
          res.data.countries.length > 0 &&
          this.selectedContact.country &&
          this.countriesTV.length != res.data.countries.length
        ) {
          this.selectedContact.city = res.data.countries[0].country;
        }
      });
    });

    // Venue Subscription

    // this.$subscribeTo(this.venuSearchSubject$.asObservable().pipe(debounceTime(300), distinctUntilChanged()), searchString => {
    // console.error(this.venuSearchString);

    //   BookingService.searchVenu({
    //     city: this.city,
    //     country: this.country,
    //     search: searchString
    //   }).then(res => {
    //     console.log(res);
    //     this.venues = res.data.venues;
    //   });
    // });

    // Promoter Subscription

    // this.$subscribeTo(this.promoterSearchSubject$.asObservable().pipe(debounceTime(300), distinctUntilChanged()), searchString => {
    //   console.error(searchString);

    //   BookingService.findBookingPromoter({
    //     city: this.city,
    //     country: this.country,
    //     search: searchString
    //   }).then(res => {
    //     this.promoters = res.data.contacts;
    //   });
    // });
    // Contact Subscription

    // this.$subscribeTo(this.contactSearchSubject$.asObservable().pipe(debounceTime(300), distinctUntilChanged()), searchString => {
    //   console.error(searchString);

    //   BookingService.searchContactBookingWizard({
    //     search: searchString
    //   }).then(res => {
    //     this.contacts = res.data.contacts;
    //   });
    // });

    // ! Temporary Venu initialization, Remove this later
    // this.city = 'London';
    // this.country = 'United Kingdom';
    // this.eventName = 'Demo Event Name'
    // this.selectedArtists = new Set(["88", "126", "103"]);
    // this.initVenuTab().then(res => this.selectedVenue = this.venues[0]);

    // ! Temporary Promoter initialization, Remove this later
    // this.initPromoterTab().then(res => this.selectedPromoter = this.promoters[2]);
    // this.activeTab = '3';

    // !Temporary COntact initialization
    // this.initContactTab();
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {
        if (to.query && to.query.start_date && to.query.start_date.length > 0) {
          this.startDate = format(to.query.start_date, "YYYY-MM-DD"); // new Date(to.query.start_date);
          if (to.query.end_date) {
            this.endDate = format(to.query.end_date, "YYYY-MM-DD"); // new Date(to.query.end_date);
          } else {
            this.endDate = format(to.query.start_date, "YYYY-MM-DD"); // new Date(to.query.start_date);
          }
        }
      },
    },
    addBookingData: {
      immediate: true,
      handler: function (newValue, oldValue) {
        // console.log(newValue);
        if (!newValue) {
          return;
        }
        keys(newValue).map((key) => {
          this[key] = newValue[key];
          if (key === "selectedArtists") {
            // console.log('selectedArtists', this[key], newValue[key]);
          }
        });
        // console.log(newValue, this.$data);
      },
    },
    activeTab: {
      immediate: true,
      handler: function (newValue, oldValue) {
        // console.error("ActiveTabv change", this.city);

        if (newValue == 1) {
          this.initVenuTab();
        } else if (newValue == 2) {
          this.initPromoterTab();
        } else if (newValue == 3) {
          this.initContactTab();
        }
      },
    },
  },
  computed: {
    ...mapGetters(["systemLanguagesTV"]),

    isBasicFormValid: function () {
      // console.log(this.validationResult, {
      //   'resultValidity(this.validationResult)': resultValidity(this.validationResult)
      // });
      return resultValidity(this.validationResult);
    },
    isvenueFormValid: function () {
      return this.selectedVenue && this.isVenueFormValidated();
    },
    isArtistSelected: function () {
      // console.log('isArtistSelected', this.selectedArtists, this.selectedArtists.size > 0);
      return this.selectedArtists.size > 0;
    },
    isBasicTabNextable: function () {
      return (
        this.activeTab == 0 && this.isBasicFormValid && this.isArtistSelected
      );
    },
    isVenuTabNextable: function () {
      // console.log(this.activeTab, typeof this.activeTab);
      return (
        this.activeTab == 1 &&
        this.isvenueFormValid &&
        this.isBasicFormValid &&
        this.isArtistSelected
      );
    },
    isPromoterTabTextable: function () {
      return (
        this.activeTab == 2 &&
        this.isvenueFormValid &&
        this.isBasicFormValid &&
        this.isArtistSelected &&
        this.isPromoterValidated()
      );
    },
    isNextButtonEnabled: function () {
      // return true;
      return any(identity, [
        this.isBasicTabNextable,
        this.isVenuTabNextable,
        this.isPromoterTabTextable,
      ]);
    },
    isBackButtonEnabled: function () {
      return this.activeTab != 0;
    },
    isPromoterFinishable: function () {
      return this.activeTab == 2
        ? this.isvenueFormValid &&
            this.isBasicFormValid &&
            this.isArtistSelected &&
            this.isPromoterValidated()
        : this.isvenueFormValid &&
            this.isBasicFormValid &&
            this.isArtistSelected;
    },
    isFinishEnabled: function () {
      console.log({
        "this.isBasicFormValid": this.isBasicFormValid,
        "this.isArtistSelected": this.isArtistSelected,
        "this.isPromoterFinishable": this.isPromoterFinishable,
      });

      return (
        this.isBasicFormValid &&
        this.isArtistSelected &&
        this.isPromoterFinishable &&
        !this.finishLoadingFlag
      );
    },
    isFinishEnabledTitle: function () {
      if (this.isBasicFormValid) {
        if (
          this.isArtistSelected &&
          this.isPromoterFinishable &&
          !this.finishLoadingFlag
        ) {
          return "Finish";
        } else {
          return this.$t("input_required_fields_message");
        }
      } else {
        const requiredInvalidFields = toPairs(this.validationResult)
          .filter(([key, value]) => !value.valid)
          .map(([key, value]) => key)
          .join(", ");
        return `${this.$t(
          "input_required_fields_message"
        )} - ${requiredInvalidFields}`;
      }
    },
    isNextTabVisible: function () {
      return this.activeTab < 3;
    },
    isBackTabVisible: function () {
      return this.activeTab > 0;
    },
    countriesTV: function () {
      return createCountriesTV(this.countries || []);
    },

    createNewButtonText: function () {
      return {
        1: "Venue",
        2: "Promoter",
        3: "Contact",
      }[this.activeTab];
    },
    newButtonShow: function () {
      switch (parseInt(this.activeTab)) {
        case 0: {
          return false;
        }
        case 2: {
          if (ContactFuncs.isNewContact(this.selectedPromoter)) {
            return false;
          } else {
            return true;
          }
        }
        case 3: {
          if (ContactFuncs.isNewContact(this.selectedContact)) {
            return false;
          } else {
            return true;
          }
        }
        default: {
          return true;
        }
      }
      return;
    },
    nextButtonText: function () {
      if (this.activeTab == 2) {
        if (ContactFuncs.isNewContact(this.selectedPromoter)) {
          return `Next(Verify)`;
        } else if (this.linkablePromoters.length > 0) {
          return `Next(Continue)`;
        } else if (this.promoterVerifying) {
          return `Next(Verifying...)`;
        }
      }
      return this.$t("next");
    },
  },
  methods: {
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onCheckboxChange: function(event, artist) {
      console.log('selectedArtist Checkbox Change');
      this.selectedArtists = addRemoveSet(event.target.checked, this.selectedArtists, artist.artist_id);
    },
    onNextClick: async function (event) {
      const nextTab =
        parseInt(this.activeTab, 10) + 1 >= this.tabs.length
          ? 0
          : parseInt(this.activeTab, 10) + 1;

      if (parseInt(this.activeTab, 10) == 2 && nextTab == 3) {
        const ok = await this.nextPromoter();
        if (ok) {
          this.changeTab(nextTab);
        }
      } else {
        this.changeTab(nextTab);
      }
    },
    changeTab: function (tabNo) {
      this.activeTab = `${tabNo}`;

      // if (this.activeTab == 1) {
      //   this.initVenuTab();
      // } else if (this.activeTab == 2) {
      //   this.initPromoterTab();
      // } else if (this.activeTab == 3) {
      //   this.initContactTab();
      // }
    },
    initVenuTab: function () {
      if (this.venues && this.venues.length > 0) {
        return;
      }
      this.loading.venue = true;
      return BookingService.findVenueWizard({
        city: this.city,
      })
        .then((res) => {
          this.venues = res.data.venues;
        })
        .finally(() => {
          this.loading.venue = false;
        });
    },
    onBackClick: function (event) {
      const backTab =
        parseInt(this.activeTab, 10) - 1 < 0
          ? this.tabs.length - 1
          : parseInt(this.activeTab, 10) - 1;
      this.activeTab = `${backTab}`;
    },
    onValidation: function (id, validationResult) {
      console.warn(id, validationResult);
      const stDate = new Date(this.startDate).getTime();
      const edDate = new Date(this.endDate).getTime();
      console.log(edDate - stDate);
      if (id == "endDate" || id == "startDate") {
        if (edDate - stDate < 0) {
          validationResult.valid = false;
          validationResult.errorMessages = [
            ...validationResult.errorMessages,
            "End Date Must be After Start Date",
          ];
          // NotificationService.showNotification({
          //   text: "End Date Must be After Start Date",
          //   timeout: 5000,
          //   type: "error",
          // });
        }
      }
      this.$set(this.validationResult, id, validationResult);
    },
    onDropdownChange: function (name, event) {
      switch (name) {
        case "country": {
          // console.log(event);
          // this.selectedCountry = event.value;
          this.country = event.value;
          // this.searchArtist();
          break;
        }
        case "status": {
          this.selectedStatus = event;
          break;
        }
        default: {
        }
      }
    },
    onArtistSearchInputKeyup: function (event) {
      this.artistSearchString = event.target.value;
      this.artistSearchSubject$.next(event.target.value);
    },
    // onArtistCheckboxChange: function(e, artist) {
    //   this.selectedArtists = addRemoveSet(e.target.checked, this.selectedArtists, artist.artist_id);
    // },
    // onArtistItemClick: function(e, artist) {
    //   this.selectedArtists = addRemoveSet("toggle", this.selectedArtists, artist.artist_id);
    // },
    onArtistSelected: function (selectedArtists) {
      // console.error('selectedArtist SELECT', selectedArtists);
      this.selectedArtists = selectedArtists;
    },
    searchArtist: function (searchString) {
      if(searchString){
        this.artistSearchString = searchString;
      }

      BookingService.findArtistBookingWizard({
        search: this.artistSearchString,
        start_date: this.startDate,
        end_date: this.endDate,
        city: this.city,
        country: this.country,
      }).then((res) => {
        // console.log(res);
        this.artists = res.data.artists;
      });
    },
    onCityValueChanged: function (name, value) {
      this.citySearchSubject$.next(value);
    },
    onFinishClick: async function () {
      // console.log(this.user);

      // Handling Newly Created Promoters
      console.log("getBookingPostData");
      console.log(this.getBookingPostData());
      if (parseInt(this.activeTab, 10) == 2) {
        const ok = await this.nextPromoter();
        if (!ok) {
          return;
        }
      }

      this.finishLoadingFlag = true;

      BookingService.insertBooking({
        ...this.getBookingPostData(),
      }).then((res) => {
        this.$emit("done", res.data.calendarDateID);
        this.finishLoadingFlag = false;
      });
    },
    onSelectVenue: function (venue) {
      // scrollToWithAnimation(this.$refs['venueBox'], this.$refs['venueLeft'].getBoundingClientRect().height, 150);

      this.selectedVenue = venue;
      // console.log(venue);

      const artists = Array.from(this.selectedArtists).map((element) =>
        this.artists.find((artist) => artist.artist_id == element)
      );
      // console.log(Array.from(this.selectedArtists), venue, artists);

      BookingService.findVenueContext({
        bookingLocationId: venue.booking_location_id,
        startDate: this.startDate,
        promoterId: 0,
        contactId: 0,
      }).then((res) => {
        // console.log(res);
        this.setupGoogleMap(venue, artists, this.startDate, res?.data?.warnings);
      });

      setTimeout(() => {
        // setupGoogleMap(venue, artists, this.startDate);
      }, 100);
    },

    onVenueSelected: function (selectedVenues) {
      console.log("RRRRRRRRRRRRRR", selectedVenues);
      const venueId = selectedVenues.booking_location_id; //Array.from(selectedVenues)[0];
      const venue = this.venues.find(
        (venue) => venue.booking_location_id == venueId
      );

      if (venue) {
        this.onSelectVenue(venue);
      } else {
        // console.log("The veue could not be found", venueId);
      }
    },

    onVenueValueChanged: function (name, value) {
      // console.log(name, value);
      this.selectedVenue[name] = value;
    },
    onVenueBlur: function (name, value) {
      if (this.selectedVenue["booking_location_id"] == "NEW_VENUE") {
        return;
      }
      BookingService.modifyBookingLocation({
        bookingLocationId: this.selectedVenue.booking_location_id,
        name,
        value,
      }).then((res) => {});
    },
    onVenuDropdownChange: function (name, value) {
      this.selectedVenue[name] = value.value;

      if (this.selectedVenue["booking_location_id"] == "NEW_VENUE") {
        return;
      }
      BookingService.modifyBookingLocation({
        bookingLocationId: this.selectedVenue.booking_location_id,
        name,
        value: value.value,
      }).then((res) => {});
      // console.log(name, value);
    },
    onVenueValidation: function (name, validationResult) {
      this.venueValidationResult = {
        ...this.venueValidationResult,
        [name]: validationResult,
      };
    },
    isVenueFormValidated: function () {
      // console.log(this.venueValidationResult);
      return Object.keys(this.venueValidationResult)
        .map((key) => this.venueValidationResult[key].valid)
        .every((e) => e);
    },
    // onVenueSearchKeyUp: function(event) {
    //   this.venuSearchString = event.target.value;
    //   this.venuSearchSubject$.next(this.venuSearchString);
    // },
    searchVenue: function (bookingLocationName) {
      this.venuSearchString = bookingLocationName;
      BookingService.searchVenu({
        city: this.city,
        country: this.country,
        search: bookingLocationName,
      }).then((res) => {
        this.venues = res.data.venues;
      });
    },
    onMapMouseEnter: function (event) {
      // console.log(this.$refs.mapContainer, this.$refs.expandedMapContainer);
      this.mapExpanded = true;
      this.$refs.expandedMapContainer.appendChild(this.$refs.mapElement);

      // console.log("menter");
    },
    onMapMouseLeave: function (event) {
      this.mapExpanded = false;
      this.$refs.mapContainer.appendChild(this.$refs.mapElement);
    },
    setupGoogleMap: async function (venue, artists, startDate, venues) {
      // console.log(artists);

      const placeId = venue.google_place_id;

      const { latitude, longitude } = venue;

      this.map = true;

      await wait();

      const mapElement = document.getElementById("google-map-element");

      if (!google) {
        // console.error('Google Map Kit could not be fetched');
        return;
      }

      const map = new google.maps.Map(mapElement, {
        center: { lat: parseFloat(latitude), lng: parseFloat(longitude) },
        zoom: 12,
      });

      const marker = new google.maps.Marker({
        map,
        place: {
          placeId: placeId,
          location: { lat: parseFloat(latitude), lng: parseFloat(longitude) },
        },
        label: head(venue.booking_location_name),
        title: venue.booking_location_name,
        icon: {
          url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
        },
      });

      // console.log({
      //   marker1: {
      //     title: venue.booking_location_name,
      //     place: {
      //       placeId: placeId,
      //       location: { lat: parseFloat(latitude), lng: parseFloat(longitude) }
      //     }
      //   },
      //   venues
      // });

      const markers = venues.map(
        (ven) =>
          new google.maps.Marker({
            map,
            position: {
              lat: parseFloat(ven.latitude),
              lng: parseFloat(ven.longitude),
            },
            label: head(ven.booking_location_name),
            title: ven.booking_location_name,
          })
      );

      const getContentString = ({
        bookingLocationName,
        startDate,
        artists,
      }) => `

      <h2>${bookingLocationName}</h2>
      <h3>Date: ${startDate}</h3>  
      <h4>Artist(s): ${artists}</h4>  
      
      `;

      const venueContexts = await Promise.all(
        venues.map((ven) =>
          BookingService.findVenueContextByCalendarDate({
            calendarDateId: ven.calendar_date_id,
          })
        )
      );

      // console.log(venueContexts);

      const infoData = zip(
        venues,
        venueContexts.map((c) => c.data.map((d) => d.artist_name))
      );

      // console.log(infoData);

      const infoWindows = infoData.map(([venue, artists]) => {
        return new google.maps.InfoWindow({
          content: getContentString({
            bookingLocationName: venue.booking_location_name,
            startDate: venue.start_date,
            artists: artists,
          }),
        });
      });

      this.markerInfoWindows = zip(markers, infoWindows);

      zip(markers, infoWindows).map(([marker, infoWindow]) => {
        marker.addListener("click", (e) =>
          this.toggleBounce(map, marker, infoWindow)
        );
      });
    },
    toggleBounce: function (map, marker, infoWindow) {
      infoWindow.open(map, marker);

      this.markerInfoWindows.map(([mk, iw]) => {
        if (iw != infoWindow) {
          iw.close();
        }
        if (mk !== marker) {
          mk.setAnimation(null);
        }
      });

      if (marker.getAnimation() !== null) {
        marker.setAnimation(null);
      } else {
        marker.setAnimation(google.maps.Animation.BOUNCE);
      }
    },

    onAddVenue: function () {
      // this.selectedVenue = createVenue({
      //   booking_location_id: 'NEW_VENUE',
      //   booking_location_name: this.venuSearchString,
      //   city: this.city,
      //   country: this.country,
      // });
      this.selectedVenue = VenueFuncs.createNewVenue({
        booking_location_name: this.venuSearchString,
        city: this.city,
        country: this.country,
      });

      // console.log(this.selectedVenue, this.venuSearchString);
    },

    // Promoter Functions

    initPromoterTab: function () {
      if (this.promoters && this.promoters.length > 0) {
        return;
      }
      this.loading.promoter = true;
      return BookingService.findBookingPromoter({
        search: this.city,
        city: this.city,
        country: this.country,
      })
        .then((res) => {
          this.promoters = res.data.contacts;
        })
        .finally(() => {
          this.loading.promoter = false;
        });
    },
    onSelectPromoter: async function (promoter) {
      // scrollToWithAnimation(this.$refs['promoterBox'], this.$refs['promoterLeft'].getBoundingClientRect().height, 150);

      if (this.linkablePromoters && this.linkablePromoters.length > 0) {
        // If the list is Linkable Promoters then - Dont check for venueContext and Contact is Promoter

        await BookingService.linkToPromoter({
          promoterId: promoter.promoter_id,
          contactId: this.selectedPromoter.contact_id,
        });

        this.linkablePromoters = [];

        this.changeTab(3);

        return;
      }

      this.selectedPromoter = ContactFuncs.createContact(promoter);

      // Find Venue Context -- Has the comments

      BookingService.findVenueContext({
        contactId: promoter.contact_id,
      }).then((res) => {
        // console.log(res);
        this.$set(
          this.selectedPromoter,
          "comments",
          res && res.data && res.data.comments
        );
      });

      // If Contact is not promoter - then Verify Contact for linking the contact to a Promoter
      BookingService.checkContactIsPromoter({
        contactId: promoter.contact_id,
      }).then((res) => {
        const isPromoter = res.data.promoter;
        if (isPromoter === 1) {
          this.selectedPromoter.isContactPromoter = true;
        } else {
          NotificationService.showNotification({
            text: "Contact is not a Promoter!",
          });
          this.selectedPromoter.isContactPromoter = false;
          this.verifyPromoter();
        }
      });
    },

    promoterSelected: function (selectedPromoter) {
      const contactId = Array.from(selectedPromoter)[0];
      const promoter = this.promoters.find(
        (promoter) => promoter.contact_id == contactId
      );

      if (promoter) {
        this.onSelectPromoter(venue);
      } else {
        // console.log("The Promoter could not be found", contactId);
      }
    },

    promoterSearched: function (searchString) {
      this.promoterSearchString = searchString;

      BookingService.findBookingPromoter({
        city: this.city,
        country: this.country,
        search: searchString,
      }).then((res) => {
        // Verified Promoter List is no more- the promoters array is the search result
        this.linkablePromoters = [];

        this.promoters = res.data.contacts;
        // console.log("Log: this.promoters", this.promoters)
      });
    },

    onPromoterSearchKeyUp: function (event) {
      this.promoterSearchString = event.target.value;
      this.promoterSearchSubject$.next(this.promoterSearchString);
    },

    getContactName: function (contact) {
      // console.log(contact);
      return ContactFuncs.getName(contact);
    },
    onPromoterValueChanged: function (name, value) {
      // console.log(this.selectedPromoter, name, value);
      this.$set(this.selectedPromoter, name, value);

      if (name == "city" && !this.selectedPromoter.country) {
        this.promoterCitySearchSubject.next(value);
      }

      // if (ContactFuncs.isNewContact(this.selectedPromoter)) {
      //   this.promoterContinue = false;
      // }
    },
    onPromoterBlur: function (name, value) {
      // console.log(name, value);
      if (ContactFuncs.isNewContact(this.selectedPromoter)) {
        return;
      }
      BookingService.modifyContact({
        contactId: this.selectedPromoter.contact_id,
        name,
        value,
      }).then((res) => {
        // console.log(res);
      });
    },
    onPromoterDropdownChange: function (name, value) {
      this.$set(this.selectedPromoter, name, value.value);
      if (ContactFuncs.isNewContact(this.selectedPromoter)) {
        return;
      }

      BookingService.modifyContact({
        contactId: this.selectedPromoter.contact_id,
        name,
        value: value.value,
      }).then((res) => {
        // console.log(res);
      });
    },

    onPromoterValidation: function (name, validationResult) {
      this.promoterValidationResult = {
        ...this.promoterValidationResult,
        [name]: validationResult,
      };
    },
    isPromoterValidated: function () {
      return Object.keys(
        ContactFuncs.omitByType(this.selectedPromoter)(
          this.promoterValidationResult
        )
      )
        .map((key) => this.promoterValidationResult[key].valid)
        .every((e) => e);
    },

    onAddPromoter: function () {
      this.selectedPromoter = ContactFuncs.createNewContact({
        city: this.city,
        country: this.country,
      });

      // this.promoterContinue = false;

      // console.log(this.selectedPromoter);
    },

    nextPromoter: async function () {
      // console.log('Next from Promoter to Contact');
      // console.log(this.selectedPromoter);
      if (
        ContactFuncs.isNewContact(this.selectedPromoter) &&
        this.isPromoterValidated()
      ) {
        const contact_id = await this.addPromoterContact();

        await this.verifyPromoter();

        if (this.linkablePromoters.length > 0) {
          return false;
        } else {
          const addPromoter = await AddBookingService.addContactToPromoter({
            contact_id,
          });
          return true;
        }
      }

      // This is the Second Click - After (First Click) A new Promoter is Verified
      // if (
      //   !ContactFuncs.isNewContact(this.selectedPromoter) &&
      //   !this.selectedPromoter.add_contact_to_promoter &&
      //   this.linkablePromoters.length > 0
      // ) {
      //   const { contact_id } = this.selectedPromoter;

      //   const addPromoter = await AddBookingService.addContactToPromoter({
      //     contact_id,
      //   });
      //   this.selectedPromoter = {
      //     ...this.selectedPromoter,
      //     add_contact_to_promoter: true,
      //   };
      //   return true;
      // }
      if (
        !ContactFuncs.isNewContact(this.selectedPromoter) &&
        !this.selectedPromoter.add_contact_to_promoter &&
        this.selectedPromoter.isContactPromoter === false
      ) {
        const { contact_id } = this.selectedPromoter;

        const addPromoter = await AddBookingService.addContactToPromoter({
          contact_id,
        });
        this.selectedPromoter = {
          ...this.selectedPromoter,
          add_contact_to_promoter: true,
          isContactPromoter: true,
        };
        return true;
      }

      return true;
    },

    verifyPromoter: async function () {
      this.promoterVerifying = true;
      const promoters = await AddBookingService.verifyPromoter(
        this.selectedPromoter
      ).then((res) => res?.data?.promoters);
      this.promoterVerifying = false;
      this.linkablePromoters = promoters ? promoters : [];
    },

    addPromoterContact: async function () {
      let contact_id;
      try {
        contact_id = await AddBookingService.addPromoter(
          this.selectedPromoter
        ).then((res) => res.data.contact_id);
        // console.log(contact_id);
      } catch (e) {
        return false;
      }

      if (contact_id) {
        // console.log('Setting the Contact ID, Promoter is no more a new contact');
        this.selectedPromoter = {
          ...this.selectedPromoter,
          contact_id,
        };
      }
      NotificationService.showNotification({
        text: "New Contact Added!",
      });
      return contact_id;
    },

    // Contact Methods

    initContactTab: function () {
      if (this.contacts && this.contacts.length > 0) {
        return;
      }
      this.loading.contact = true;
      return BookingService.findWizard3({
        city: this.city,
      })
        .then((res) => {
          this.contacts = res.data && res.data.contacts;
        })
        .finally(() => {
          this.loading.contact = false;
        });
    },

    onContactSearchKeyUp: function (event) {
      this.contactSearchString = event.target.value;
      this.contactSearchSubject$.next(this.contactSearchString);
    },
    onSelectContact: function (contact) {
      // scrollToWithAnimation(this.$refs['contactBox'], this.$refs['contactLeft'].getBoundingClientRect().height, 150);

      this.selectedContact = contact;
      // console.log(this.selectedContact);
    },
    searchContact: function (searchString) {
      this.contactSearchString = searchString;
      BookingService.searchContactBookingWizard({
        search: searchString,
      }).then((res) => {
        this.contacts = res.data.contacts;
      });
    },
    onContactValueChanged: function (name, value) {
      this.$set(this.selectedContact, name, value);

      // If City is entered without a Valid Set Country
      if (name == "city" && !this.selectedContact.country) {
        this.contactCitySearchSubject.next(value);
      }
    },
    onContactBlur: function (name, value) {
      if (ContactFuncs.isNewContact(this.selectedContact)) {
        return;
      }
      BookingService.modifyContact({
        contactId: this.selectedContact.contact_id,
        name,
        value,
      }).then((res) => {
        // console.log(res);
      });
    },

    onContactDropdownChange: function (name, event) {
      this.$set(this.selectedContact, name, event.value);
      const value = event.value;
      if (ContactFuncs.isNewContact(this.selectedContact)) {
        return;
      }
      BookingService.modifyContact({
        contactId: this.selectedContact.contact_id,
        name,
        value,
      }).then((res) => {
        // console.log(res);
      });
    },

    onAddContact: function () {
      // this.selectedContact = createContact({
      //   contact_id: this.contactSearchString,
      //   city: this.city,
      //   country: this.country,
      // });

      const [first_name, last_name] =
        this.contactSearchString?.split(" ") || [];

      this.selectedContact = ContactFuncs.createNewContact({
        first_name,
        last_name,
        city: this.city,
        country: this.country,
      });
    },

    onContactValidation: function (name, validationResult) {
      this.contactValidationResult = {
        ...this.contactValidationResult,
        [name]: validationResult,
      };
    },
    isContactValidated: function () {
      return Object.keys(this.contactValidationResult)
        .map((key) => this.contactValidationResult[key].valid)
        .every((e) => e);
    },

    // Overall Methods

    getBookingPostData: function () {
      return {
        notOK: false,
        ...// this.activeTab > 2 &&
        (this.selectedContact &&
          ((this.selectedContact.contact_id &&
            this.isContactValidated() &&
            ContactFuncs.isNewContact(this.selectedContact)) ||
          !ContactFuncs.isNewContact(this.selectedContact)
            ? {
                contact_first_name: this.selectedContact.first_name,
                contact_last_name: this.selectedContact.last_name,
                contact_phone1: this.selectedContact.phone1,
                contact_phone2: this.selectedContact.mobile1,
                contact_email1: this.selectedContact.email1,
                contact_city: this.selectedContact.city,
                contact_postalcode: this.selectedContact.postalcode,
                contact_country: this.selectedContact.country,
                contact_language: this.selectedContact.language,
                contact_id_promoter2: ContactFuncs.isNewContact(
                  this.selectedContact
                )
                  ? ""
                  : this.selectedContact.contact_id, // !What does the key mean?
                new_contact: ContactFuncs.isNewContact(this.selectedContact)
                  ? 1
                  : 0,
              }
            : {})),
        ...// this.activeTab > 1 &&
        (this.selectedPromoter &&
        this.selectedPromoter.contact_id &&
        this.isPromoterValidated() &&
        !ContactFuncs.isNewContact(this.selectedPromoter)
          ? {
              contact_id_promoter: this.selectedPromoter.contact_id, // !What does the key mean?
              promoter_name: getName(this.selectedPromoter),
              promoter_address1: this.selectedPromoter.address1,
              promoter_city: this.selectedPromoter.city,
              promoter_postalcode: this.selectedPromoter.postalcode,
              promoter_country: this.selectedPromoter.country,
              promoter_region: this.selectedPromoter.region,
              promoter_phone1: this.selectedPromoter.phone1,
              promoter_phone2: this.selectedPromoter.mobile1,
              promoter_email1: this.selectedPromoter.email1,
              promoter_vat_no: this.selectedPromoter.vat_no,
              promoter_url1: this.selectedPromoter.url1,
              promoter_language: this.selectedPromoter.language,
            }
          : {}),
        ...// this.activeTab > 0 &&
        (this.selectedVenue &&
        this.selectedVenue.booking_location_id &&
        this.isVenueFormValidated()
          ? {
              venueName: this.selectedVenue.booking_location_name,
              venueAddress1: this.selectedVenue.address1,
              venueCity: this.selectedVenue.city,
              venuePostalcode: this.selectedVenue.postalcode,
              venueCountry: this.selectedVenue.country,
              venuePhone1: this.selectedVenue.phone1,
              venueEmail: this.selectedVenue.email,
              venueURL1: this.selectedVenue.url1,
              venueCapacity: this.selectedVenue.venue_capacity,
              bookingLocationID: VenueFuncs.isNewVenue(this.selectedVenue)
                ? ""
                : this.selectedVenue.booking_location_id,
              newVenue: VenueFuncs.isNewVenue(this.selectedVenue) ? 1 : 0,
            }
          : {}),
        ...(this.calendarDateId && {
          calendar_date_id: this.calendarDateId,
        }),
        startDate: this.startDate,
        endDate: this.endDate,
        city: this.city,
        country: this.country,
        dateName: this.eventName,
        bookingStatusID: this.selectedStatus && this.selectedStatus.value,
        first_offer_notes: this.dealMemo,
        artists: `[${Array.from(this.selectedArtists)
          .map((e) => parseInt(e))
          .join(",")}]`,
        section: "bookings",
        action: `finish_booking_wizard_step_${
          parseInt(this.activeTab, 10) + 1
        }`,
        userID: this.user.user_id,
        currency: this.$store.getters.account.client.default_currency,
      };
    },
    onTabChange: function (changedTab) {
      // console.log(changeTab);
    },

    onNewClick: function () {
      // console.log(this.activeTab);
      switch (parseInt(this.activeTab)) {
        case 1: {
          this.onAddVenue();
          break;
        }
        case 2: {
          this.onAddPromoter();
          break;
        }
        case 3: {
          this.onAddContact();
          break;
        }
      }
    },

    onStartDateChanged: function (name, value) {
      // console.log({name, value});
      this.startDate = value;
      this.endDate = value;
    },
    onEndDateChanged: function (name, value) {
      // console.log(this.startDate,this.endDate);
      // if(this.startDate && this.startDate!=""){
      //   const stDate=new Date(this.startDate).getTime();
      //   const edDate=new Date(value).getTime();
      //   console.log(edDate-stDate);
      //   this.endDate=(edDate-stDate)>0?value:'';

      // }else{
      //     this.endDate = '';
      //    NotificationService.showNotification({
      //     text: "End Date Must be Bigger Than Start Date",
      //     timeout: 5000,
      //     type: "error",
      //   });

      // }
      this.endDate = value;
    },

    onArtistListScroll: async function (payload) {
      console.log(":::", this.artists);

      const listArtist = await AddBookingService.bookingWizardArtistPage(
        this.artistRowCount
      );

      console.log("::", listArtist, "::");

      if (listArtist.data.artists.length > 0) {
        this.artists = [...this.artists, ...listArtist.data.artists];
        console.log("::: artist", this.artists);
        this.artistRowCount += 100;
      }
    },
    // Mark: Methods
  },
};
</script>

<style lang="scss" scoped>
.status {
  .status-color {
    width: 11px;
    min-width: 11px;
    height: 11px;
    border-radius: 50%;
    margin-top: 5.5px;
  }
  .status-text {
    margin-left: 10px;
  }
}
</style>

<style lang="scss">
@import "src/style/responsive.scss";

.cmp-add-booking {
  .dt-modal--subtitle {
    margin-top: 0px !important;
  }

  .tab-content {
    .form-group {
      padding: 0px 1px 1px;
      // padding-right: 1px;
      // max-height: 450px;
      overflow: auto;
    }

    &.basic-setup {
      .dt-table2 {
        --body-height: 372px;
        tbody {
          min-height: 372px;
        }
      }
      .dt-dropdown {
        // margin-left: 5px;
        // margin-right: 5px;
        // .dropdown--list {
        //   max-height: 300px;
        //   background: green;
        // }
      }
    }

    &.venues {
      position: relative;

      // .dt-table2 {
      //   --body-height: 400px !important;
      // }

      #google-map-element {
        height: 490px;

        &.expanded {
          position: absolute !important;
          width: 100%;
          height: 100%;
          top: 0px;
          left: 0px;
        }
      }
    }

    &.venues,
    &.promoters,
    &.contacts {
      .form-group {
        max-height: 426px;
        padding-top: 15px;
      }
      .dt-table2 {
        --body-height: 400px !important;
        tbody {
          min-height: 400px !important;
        }
      }
    }
  }
  .form-group {
    .dt-input-box {
      // margin: 5px 0px;
    }
    .dt-dropdown {
      // margin-left: 5px;
      // margin-right: 5px;
    }

    .group-input {
      // margin: 10px 0px;
      text-align: left;
    }
  }

  .box-container {
    // height: calc(100vh - 450px);
  }

  .tab-content {
    height: 100%;
  }

  // .artist-side {
  //   height: 100%;
  //   .artists-container {
  //     .artists {
  //       .artist-item {
  //         padding: 5px;

  //         .checkbox-container {
  //           padding: 5px 0px;
  //         }

  //         &:nth-child(4n + 1),
  //         &:nth-child(4n + 4) {
  //           background: var(--sprt-8);
  //         }
  //         .artist-name {
  //           cursor: pointer;
  //         }
  //       }
  //     }
  //   }
  // }

  .venues {
    // overflow: auto;
    // max-height: 500px;

    .venue-item {
    }
  }

  .venue-search {
    width: 100%;
  }

  .venue-form-container {
    .venue-form-box {
      overflow: auto;

      .venue-form {
      }
    }
  }

  .ab-entity {
    // overflow: auto;
    // max-height: 500px;

    .ab-entity-item {
    }
  }

  .ab-entity-search {
    width: 100%;
  }

  .ab-entity-form-container {
    max-height: 500px;

    .layout {
      height: 100%;
    }

    .ab-entity-form-box {
      overflow: auto;

      .ab-entity-form {
      }
    }

    .comment-container {
      height: 40%;
    }
  }

  // height: calc(100vh - 5px) !important;
  display: flex;
  flex-direction: column;

  @media (min-width: 320px) and (max-width: 480px) {
    padding: 10px;

    .dt-modal--title-bar {
      margin-top: 0px;
    }
  }

  .dt-modal--body {
    // height: 100%;      // Creates Problem with a Child Element - Lower Options Layout Row by not containing it
    display: flex;
    flex-direction: column;
    overflow: auto;

    & > .tabs {
      flex: 1;

      .tabs__items {
        height: 100%;

        @media (min-width: 320px) and (max-width: 480px) {
          height: calc(100vh - 185px);
        }
        .tabs__content {
          height: 100%;
          @include tabland-up() {
            max-height: 488px;
            min-height: 488px;
          }
          .card {
            height: 100% !important;
            & > .layout {
              height: 100%;
              & > .box-container {
                height: 100%;

                & > div {
                  height: 100%;
                }

                .flex.half {
                  height: 100%;

                  .artists-container {
                    // display: none;
                    overflow: auto;
                    // height: 10px;
                    height: calc(100vh - 286px) !important;
                    // height: calc(100% - 10px);
                  }

                  .contact-search {
                    @media (min-width: 320px) and (max-width: 480px) {
                      padding-left: 15px;
                    }
                  }

                  &.half {
                    .half-list {
                      overflow: auto;
                      height: calc(100vh - 280px) !important;
                      .item {
                        & > .layout {
                          & > .flex {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;

                            max-width: 200px;
                            @media (min-width: 320px) and (max-width: 480px) {
                              max-width: 100px;
                            }
                          }
                        }
                      }
                    }
                  }
                  &.half-form-container {
                    .box-body {
                      height: calc(100vh - 260px) !important;
                    }
                  }
                }
              }
            }
          }

          .second-half {
            .add-item {
              display: flex;
              flex-direction: column;
              justify-content: center;
              height: 420px;
              .add-item--row {
                display: flex;
                justify-content: center;
              }
            }
          }

          .dt-modal--column.first-half {
            .linkable_promoters-search-list {
              .dt-table2--row {
                background: #5a5a5a;
                color: white;
              }
            }
          }
        }
      }
    }
    & > .layout {
      flex: 0.1;
    }
  }

  .bottom-controls {
    padding: 15px 3px 0px 3px;
  }
}
</style>
